module.exports = __webpack_public_path__ + "img/video-player/nervous-31bd52e6d05062939d7114d9b0578acd.png";